<script lang="ts" setup>
const nameInput = ref()
const mailInput = ref()
const messageInput = ref()
const form = ref()

const { $stableform } = useNuxtApp()

onMounted(() => {
  const stableForm = new $stableform({
    formId: '67bdfde522da7ec89063653f',
    apiKey: 'B40E39D5-CBE7-4280-BD0F-4AFA0EA633EB',
  })
    .on('success', (data) => {
      nameInput.value = ''
      mailInput.value = ''
      messageInput.value = ''

      // $swal({
      //   title: 'Formulaire envoyé',
      //   icon: 'success',
      //   confirmButtonColor: '#105391',
      //   timer: 3000,
      // })
    })
    .on('error', (err) => {
      console.error(err)
      // alert(StableForm.friendlyError(err, i18n.locale))
    })
    .subscribeTo(form.value)
})
</script>

<template>
  <div
    class="max-w-7xl mx-auto px-6 md:px-12 xl:px-6 my-10 bg-gray-900"
    id="contact"
  >
    <div
      class="relative text-secondary shadow-lg overflow-hidden bg-primary rounded-2xl flex flex-col lg:flex-row motion-opacity-0 motion-scale-in-90 motion-delay-200 intersect:motion-opacity-in-0"
    >
      <!-- Texte -->
      <div
        class="p-8 lg:p-16 flex flex-col justify-center space-y-6 lg:w-1/2 text-center lg:text-left"
      >
        <h2 class="text-3xl md:text-5xl font-extrabold">Demandez une démo !</h2>
        <p class="text-sm md:text-lg">
          Vous voulez voir SecuVerif en action ? Contactez-nous pour une
          démonstration gratuite et découvrez comment notre solution peut
          transformer la gestion de votre agence.
        </p>
      </div>
      <!-- Formulaire -->
      <div
        class="bg-white text-secondary p-6 lg:w-1/2 rounded-b-2xl lg:rounded-r-2xl lg:rounded-bl-none"
      >
        <form class="space-y-4" id="contact-form" ref="form">
          <div class="space-y-1">
            <label for="name" class="text-sm font-medium text-gray-700"
              >Nom</label
            >
            <input
              id="name"
              name="name"
              type="text"
              v-model="nameInput"
              placeholder="Votre nom"
              class="w-full px-3 py-2 text-sm border rounded-lg border-secondary/30 bg-white focus:ring-0 outline-none focus:border-primary-600"
            />
          </div>
          <div class="space-y-1">
            <label for="email" class="text-sm font-medium text-gray-700"
              >Email</label
            >
            <input
              id="email"
              v-model="mailInput"
              type="email"
              name="email"
              placeholder="Votre email"
              class="w-full px-3 py-2 text-sm border rounded-lg border-secondary/30 bg-white focus:ring-0 outline-none focus:border-primary-600"
            />
          </div>
          <div class="space-y-1">
            <label for="message" class="text-sm font-medium text-gray-700"
              >Message</label
            >
            <textarea
              id="message"
              name="message"
              v-model="messageInput"
              placeholder="Votre message"
              rows="3"
              class="w-full px-3 py-2 text-sm border rounded-lg border-secondary/30 bg-white focus:ring-0 outline-none focus:border-primary-600"
            ></textarea>
          </div>
          <button
            type="submit"
            @click="handleSubmit"
            class="w-full py-2 text-sm bg-primary-600 rounded-lg text-secondary font-semibold hover:bg-primary-700 transition"
          >
            Demander une démo
          </button>
        </form>
      </div>
    </div>
  </div>

  <footer class="py-20 pb-[300px] relative" id="footer">
    <div class="max-w-7xl mx-auto px-6 md:px-12 xl:px-6 justify-items-center">
      <div class="md:w-10/12 lg:w-8/12 xl:w-6/12">
        <div class="flex flex-wrap items-center md:flex-nowrap">
          <div class="text-center space-y-6">
            <span class="block text-secondary"
              >© 2024 Sécuvérif - Tous droits réservés | 64 rue raymond IV ,
              31000 Toulouse, France</span
            >
            <span class="block text-secondary"
              >Made with ♡ by
              <a
                href="https://ezyostudio.com/"
                class="font-semibold text-gray-600 hover:text-primary-700 transition"
              >
                EzyoStudio &copy</a
              >
              <span id="year"></span
            ></span>
            <span class="block text-secondary"
              >Besoin d'aide?
              <a
                href="#contact"
                class="font-semibold text-secondary hover:text-primary-700 transition"
              >
                Contactez-nous</a
              ></span
            >
          </div>
        </div>
      </div>
    </div>
    <!-- <div
      aria-hidden="true"
      class="absolute h-max w-full m-auto grid grid-cols-2 -space-x-52 opacity-40  z-0 "
    >
      <div
        class="blur-[106px] h-56 bg-gradient-to-br from-primary to-purple-400 "
      ></div>
      <div
        class="blur-[106px] h-32 bg-gradient-to-r from-cyan-400 to-sky-300 "
      ></div>
    </div> -->
  </footer>

  <!-- 
<div class="max-w-7xl mx-auto px-6 md:px-12 xl:px-6 my-10">
  <div class="relative text-gray-900 shadow-lg overflow-hidden  rounded-2xl">
    <div class="md:w-1/2 p-12 lg:p-16 absolute inset-0 z-10 flex flex-col justify-center space-y-6 bg-primary">
      <h2 class="text-5xl font-extrabold">Contactez-nous</h2>
      <p class="text-lg">Nous serions ravis de discuter avec vous. Pour toute demande ou assistance, n'hésitez pas à nous envoyer un message.</p>
    </div>

    <div class="md:w-1/2 ml-auto  text-gray-800 relative z-20 py-8 px-6 bg-white p-4">
        <form class="space-y-4">
          <div class="space-y-1">
            <label for="name" class="text-sm font-medium text-gray-700">Nom</label>
            <input 
              id="name"
              type="text" 
              placeholder="Votre nom" 
              class="w-full px-3 py-2 text-sm border rounded-lg border-gray-300 bg-white focus:ring-2 focus:ring-offset-2 focus:ring-primary"
            >
          </div>
          <div class="space-y-1">
            <label for="email" class="text-sm font-medium  text-gray-700">Email</label>
            <input 
              id="email"
              type="email" 
              placeholder="Votre email" 
              class="w-full px-3 py-2 text-sm border rounded-lg border-gray-300 bg-white focus:ring-2 focus:ring-offset-2 focus:ring-primary"
            >
          </div>
          <div class="space-y-1">
            <label for="message" class="text-sm font-medium text-gray-700">Message</label>
            <textarea 
              id="message"
              placeholder="Votre message" 
              rows="3" 
              class="w-full px-3 py-2 text-sm border rounded-lg border-gray-300 bg-white focus:ring-2 focus:ring-offset-2 focus:ring-primary"
            ></textarea>
          </div>
          <button 
            type="submit" 
            class="w-full py-2 text-sm bg-primary rounded-lg text-gray-900 font-semibold hover:bg-primary-700 transition"
          >Envoyer</button>
        </form>
    </div>
  </div>
</div>
<footer class="py-20 relative">
  <div aria-hidden="true" class="absolute inset-0 h-max w-full m-auto grid grid-cols-2 -space-x-52 opacity-40 ">
    <div class="blur-[106px] h-56 bg-gradient-to-br from-primary to-purple-400 "></div>
    <div class="blur-[106px] h-32 bg-gradient-to-r from-cyan-400 to-sky-300 "></div>
  </div>
  <div class="max-w-7xl mx-auto px-6 md:px-12 xl:px-6 justify-items-center">
    <div class=" md:w-10/12 lg:w-8/12 xl:w-6/12 ">
        <div class="flex flex-wrap items-center  md:flex-nowrap">
          <div
            class="text-center space-y-6"
          >
            <span class="block text-gray-500 "
              >© 2024 xPirience Sàrl - Tous droits réservés | Rue du Marché 5, 1204 Genève, Suisse</span
            >
            <span class="block text-gray-500 ">Maintenu avec ♡ par EzyoStudio. &copy; <span id="year"></span></span>
            <span class="block text-gray-500 "
              >Besoin d'aide? <a href="#" class="font-semibold text-gray-600 "> Contactez-nous</a></span
            >
          </div>
        </div>
      </div>
    </div>
</footer> -->
</template>
